import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DynamicStyleComponent } from './dynamic-style.component';
import { SafeCssDirective } from './safe-css.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [DynamicStyleComponent, SafeCssDirective],
  exports: [DynamicStyleComponent, SafeCssDirective],
})
export class DynamicStyleModule {}
